<template>
    <div class="member-favorites">
        <div class="header">
            <svg><use xlink:href="#love"></use></svg>
            <h3>Member Favorites</h3>
            <div class="slider-arrows" id="member-favorites-controls"></div>
        </div>
        <div class="body">
            <div id="member-favorites-slider">
                <a  v-for="spot in spots"
                    :key="`most-loved-spot-${spot.id}`"
                    class="wrapper"
                    :href="spot.destination_spot_url">

                    <div class="background" :style="getBackgroundImageStyle(spot)">

                        <div class="bg-black"></div>
                        <div  class="spot">

                            <!-- Title Spot -->
                            <h3 class="title" v-text="spot.title"></h3>

                            <!-- Published by a Real Member -->
                            <div class="member" v-if="spot.discovered_by">
                                <img class="avatar" :src="spot.discovered_by.md_avatar" :alt="spot.discovered_by.full_name">
                                By <span v-text="spot.discovered_by.full_name"></span>
                            </div>

                            <!-- Published by WT -->
                            <div class="member" v-else>
                                <div class="wt-logo">
                                    <svg><use xlink:href="#star"></use></svg>
                                </div>
                                By <span>Well Traveled</span>
                            </div>
                        </div>

                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    props: ['spots'],

    mounted(){
        this.$nextTick(() => {
            $('#member-favorites-slider').slick({
                infinite: true,
                centerMode: true,
                slidesToShow: 4,
                arrows: true,
                appendArrows: document.getElementById('member-favorites-controls'),
                prevArrow: '<span class="slick-prev"><svg><use xlink:href="#arrow"></use></svg></span>',
                nextArrow: '<span class="slick-next"><svg><use xlink:href="#arrow"></use></svg></span>',
                slidesToScroll: 1,
                speed: 300,
                autoplay: false,
                responsive: [{
                    autoplay: true,
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                },{
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        centerMode: true,
                        slidesToShow: 2,
                        arrows: false,
                    }
                },{
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 2,
                    }
                },{
                    breakpoint: 1650,
                    settings: {
                        slidesToShow: 3,
                    }
                }]
            })
        })
    },

    methods: {

        getBackgroundImageStyle(spot) {
            return {
                'background-image': `url("${spot.featured_image}")`
            }
        }
    },

}
</script>
